var map = {
	"./account.svg": 23602,
	"./audio.svg": 19213,
	"./audioShortcut.svg": 86407,
	"./authManage.svg": 40794,
	"./clear.svg": 44828,
	"./code.svg": 37478,
	"./collect.svg": 87325,
	"./collectFill.svg": 85906,
	"./copy.svg": 78838,
	"./createTag.svg": 79259,
	"./createTagType.svg": 22371,
	"./createTeam.svg": 62054,
	"./document.svg": 21346,
	"./download.svg": 15253,
	"./edit.svg": 95869,
	"./exclamation.svg": 23868,
	"./file.svg": 53735,
	"./fileShortcut.svg": 27737,
	"./fileline.svg": 54797,
	"./hidden.svg": 43377,
	"./history.svg": 61991,
	"./list.svg": 99161,
	"./logo.svg": 23495,
	"./message.svg": 38166,
	"./more.svg": 36482,
	"./move.svg": 13174,
	"./newFolder.svg": 9301,
	"./organization.svg": 71940,
	"./password.svg": 39902,
	"./pdf.svg": 38001,
	"./pdfShortcut.svg": 32347,
	"./person.svg": 85258,
	"./phone.svg": 37755,
	"./picture.svg": 88201,
	"./pictureShortcut.svg": 24179,
	"./ppt.svg": 79399,
	"./pptShortcut.svg": 58937,
	"./preview.svg": 79839,
	"./public.svg": 79674,
	"./publicDownload.svg": 60578,
	"./quote.svg": 76079,
	"./quoteDelete.svg": 84950,
	"./recycle.svg": 21500,
	"./refresh.svg": 35314,
	"./rename.svg": 59523,
	"./renewal.svg": 80795,
	"./set.svg": 10635,
	"./share.svg": 85702,
	"./show.svg": 75426,
	"./space.svg": 30541,
	"./statistic.svg": 69289,
	"./tag.svg": 1163,
	"./tag2.svg": 80083,
	"./tiled.svg": 43539,
	"./transmit.svg": 52057,
	"./triangle.svg": 30013,
	"./txt.svg": 92899,
	"./txtShortcut.svg": 65077,
	"./unknown.svg": 9809,
	"./unknownShortcut.svg": 40251,
	"./update.svg": 96974,
	"./upload.svg": 29538,
	"./video.svg": 29418,
	"./videoShortcut.svg": 9800,
	"./warn.svg": 74145,
	"./word.svg": 44541,
	"./wordShortcut.svg": 91735,
	"./xlsx.svg": 63276,
	"./xlsxShortcut.svg": 26442,
	"./zip.svg": 71902,
	"./zipShortcut.svg": 73324
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;